
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XButton,
XHeader,
Group,
Cell,
CellFormPreview,
CellBox,
},
name: 'noAccess',
data () {
return {
showContent004: false,
showContent003: true,
showdetails:false
}
},
created() {
this.$vux.loading.show({
text: '数据加载中',
})
setTimeout(() => {
this.$vux.loading.hide()
}, 2000)
},
methods:{
shengao(){
alert("接口完善中");
},
}
}



// WEBPACK FOOTER //
// ./src/pages/taxDetails.vue